"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _clsx2 = _interopRequireDefault(require("clsx"));
var style = require("./style_css.js")["default"];
function _default(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp;
  wapp.styles.use(style);
  var fullPage = props.fullPage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(style.canvas, (0, _defineProperty2["default"])({}, style.fullPage, fullPage))
  });
}